module.exports = __webpack_public_path__ + "img/hero.77fc8d20.jpg";